import React from 'react'
import { array, func, object } from 'prop-types'
import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import getArrayFilters from 'Utils/getArrayFilters'
import useBreakpoint from 'Utils/useBreakpoint'
import WithListingPageContext from 'Pods/ListingPage/Components/WithListingPageContext'

function RemainingMiscellaneousFilters({
  currentSelectedFilters,
  setSelectedFilters,
  currentFilters,
  trackFilterChange,
}) {
  const windowSize = useBreakpoint()
  const shouldDisplayTitleDivider = ['xs', 'md', 'lg', 'xl', 'xxl'].includes(windowSize)

  function handleFilterChange(selectedValues) {
    const truthyValues = selectedValues.filter(Boolean)
    const truthyCount = truthyValues.length
    const currentFiltersCount = currentSelectedFilters.length
    const isFilterSelected = truthyCount > currentFiltersCount
    const isFilterDeselected = truthyCount < currentFiltersCount

    if (isFilterSelected) {
      const newFilter = truthyValues
        .filter((element) => currentSelectedFilters.every((value) => value !== element))

      if (newFilter.length) {
        const newFilterValue = newFilter.pop()

        trackFilterChange({ name: 'miscellaneous', value: newFilterValue })
      }
    }

    if (isFilterDeselected) {
      const newFilter = currentSelectedFilters
        .filter((element) => truthyValues.every((value) => value !== element))

      if (newFilter.length) {
        const newFilterValue = newFilter.pop()

        window.removeCurrentSearchFilter({ name: 'miscellaneous', value: newFilterValue })
      }
    }

    return setSelectedFilters({ name: 'miscellaneous', value: [...new Set(truthyValues)] })
  }

  if (!currentFilters) {
    return null
  }

  return (
    <div className="remaining-filters__miscellaneous">
      <FiltersSidebar
        isCollapsible={false}
        filters={[{ ...currentFilters, withTitleDivider: shouldDisplayTitleDivider }]}
        selectedFilters={currentSelectedFilters}
        onFiltersChange={handleFilterChange}
        limit={8}
        isControlled
        useNewCheckboxes
        hideShowMore
        hideLastDivider
      />
    </div>
  )
}

RemainingMiscellaneousFilters.propTypes = {
  currentSelectedFilters: array.isRequired,
  setSelectedFilters: func.isRequired,
  currentFilters: object.isRequired,
  trackFilterChange: func.isRequired,
}

const mapStateToProps = ({
  selectedFilters,
  setSelectedFilters,
  filtersOptions,
  trackFilterChange,
}) => {
  const currentFilters = filtersOptions?.miscellaneous
  const groupsSelectedFilters = selectedFilters?.miscellaneous || []
  const currentSelectedFilters = getArrayFilters(groupsSelectedFilters)

  return {
    currentSelectedFilters,
    setSelectedFilters,
    currentFilters,
    trackFilterChange,
  }
}

export default WithListingPageContext(mapStateToProps)(RemainingMiscellaneousFilters)
